import axios from 'axios';
import {REP_API_URL} from '../utils/constants.js';

class AccountMultiplierServices {
    async getCustomerMultipliers(data){
        const url = `${REP_API_URL}get-commission-scale/`;
        const headers = {
            'Content-Type': 'application/json'
        };
        let formData = data;
        return axios({
            url:url,
            method: 'GET',
            data: formData,
            headers: headers
        }).then(function(response){
            return response;
        }).catch(function(error){
            return error.response;
        });
    }

    async saveAccountMultiplierSchedule(data){
        const url = `${REP_API_URL}save-account-multiplier-schedule/`;
        const headers = {
            'Content-Type': 'application/json'
        };
        let formData = data;
        return axios({
            url:url,
            method: 'POST',
            data: formData,
            headers: headers
        }).then(function(response){
            return response;
        }).catch(function(error){
            return error.response;
        });
    }
    
    async shareAccountMultiplierSchedule(data){
        const url = `${REP_API_URL}share-account-multiplier-schedule/`;
        const headers = {
            'Content-Type': 'application/json'
        };
        let formData = data;
        return axios({
            url:url,
            method: 'POST',
            data: formData,
            headers: headers
        }).then(function(response){
            return response;
        }).catch(function(error){
            return error.response;
        });
    }

    async exportAccountMultiplierSchedule(data){
        const url = `${REP_API_URL}export-account-multiplier-schedule/`;
        const headers = {
            'Content-Type': 'application/json'
        };
        let formData = data;
        return axios({
            url:url,
            method: 'POST',
            data: formData,
            headers: headers,
            responseType: 'blob',
        }).then(function(response){
            return response;
        }).catch(function(error){
            return error.response;
        });
    }
}

export default AccountMultiplierServices;